<template>
  <MultiSelect
    v-model="selected"
    @search-change="handleSearchChange"
    :placeholder="placeholder"
    :loading="isLoading"
    :options="filteredUsers"
    :multiple="true"
    :searchable="false"
    :close-on-select="false"
    track-by="id"
    label="name"
    @select="$emit('select', $event)"
    @remove="$emit('remove', $event)"
  >
    <template v-slot:option="props">
      <div class="grid grid-cols-2">
        <span class="col-span-1 truncate mr-2">{{ props.option.name }}</span>
        <span class="col-span-1 truncate text-14 font-normal">{{ props.option.email }}</span>
      </div>
    </template>
    <template
      v-slot:selection="{ values, isOpen }"
      v-if="hidePills"
    >
      <span class="multiselect__placeholder" v-if="values.length" v-show="!isOpen">{{ placeholder }}</span>
    </template>
    <template v-slot:tag="props">
      <span class="multiselect__tag"><span>{{ props.option.name }}</span>
        <i aria-hidden="true" tabindex="0" class="multiselect__tag-icon" @keypress.enter.prevent="props.remove(props.option)" @click="props.remove(props.option)"></i>
      </span>
    </template>
  </MultiSelect>
</template>
<script>
import { mapGetters } from 'vuex';
import MultiSelect from '@/components/MultiSelect.vue';
import { cloneDeep } from 'lodash';

export default {
    name: 'UserSelectInput',
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Array,
            default() {
                return [];
            },
        },
        hidePills: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        MultiSelect,
    },
    data() {
        return {
            searchTimeout: null,
            selected: [],
        };
    },
    computed: {
        ...mapGetters({
            usersHasLoaded: 'users/hasLoaded',
            users: 'users/pagedResults',
        }),
        isLoading() {
            return this.loading || !this.usersHasLoaded;
        },
        placeholder() {
            return this.selected.length > 0 ? this.$t('groups.add-another-member') : this.$t('groups.start-typing-a-users-name');
        },
        filteredUsers() {
           const users = cloneDeep(this.users);

          return users.map((user) => {
            const u = user;

            if (this.selected.filter(selectedUser => selectedUser.id === user.id).length > 0) {
              u.$isDisabled = true;
            }
            return u;
          });
        },
    },
    methods: {
        getUsers(query) {
            this.$store.dispatch('users/PAGINATE', {
                page: 1,
                pageLimit: 10,
                searchQuery: {
                    query,
                },
            });
        },
        handleSearchChange(search) {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(this.getUsers.bind(null, search), 500);
        },
    },
    watch: {
        value(newValue) {
            this.selected = newValue;
        },
        selected(newValue) {
            this.$emit('input', newValue);
        },
    },
    mounted() {
        this.getUsers(null);
        this.selected = this.value;
    },
};
</script>
